module.exports = __webpack_public_path__ + "static/media/portal.citeasl.com.e7aacd48.png";